export default "__VITE_ASSET__BrNrWGA5__"